import { Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';
import { useFullscreenModalControls } from '../../../../modals/context/modal-context-provider';
import { useEventMetadataStore } from '../../../event-panel-form/event-metadata';

export const ManageMergedEventsModalButton = observer(
    ({ eventId }: { eventId?: number }): JSX.Element | null => {
        const eventMetadata = useEventMetadataStore().state.metadata;
        const isActive = eventMetadata?.isActive;
        const { unmergeEvents, mergeEvents } = useEnabledFeatures();
        const modalControls = useFullscreenModalControls();
        const buttonText = 'Manage Merged Events';
        // If this is a child event, use the parentId to open the modal
        // else use our id, because we are the parent
        const parentEventId = eventMetadata?.parentAgencyEventId ?? eventId;

        // If there is no `parentEventId`, return immediately because
        // the modal won't work (it requires the parent event id)
        if (!parentEventId) {
            return null;
        }

        // If we are a cleared event, don't show the button either
        if (!isActive) {
            return null;
        }

        if (unmergeEvents || mergeEvents) {
            return (
                <Button
                    onClick={() => {
                        modalControls.open({
                            type: 'MANAGE_EVENT_MERGE',
                            props: {
                                primaryEventParameters: {
                                    id: parentEventId,
                                },
                            },
                        });
                    }}
                >
                    {buttonText}
                </Button>
            );
        }
        return null;
    }
);
